import { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";

import {
  DirectionsServiceEnum,
  resolveDirectionsServiceLabel,
} from "@ryde/shared";

export interface IRoutedByIndicatorContentProps {
  directionsService?: DirectionsServiceEnum;
}

/** Label + value for the "Routed by" footer block; returns null when provider is unknown (legacy records). */
export const RoutedByIndicatorContent: FC<IRoutedByIndicatorContentProps> = ({
  directionsService,
}) => {
  const { t } = useTranslation();
  const providerLabel = useMemo(
    () => resolveDirectionsServiceLabel(directionsService),
    [directionsService],
  );

  if (!providerLabel) {
    return null;
  }

  return (
    <>
      <label>{t("general.ROUTED_BY")}</label>
      <span data-e2e="routed-by-indicator">{providerLabel}</span>
    </>
  );
};
